import script from "./DatasetStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetStats.vue?vue&type=script&setup=true&lang=js"

import "./DatasetStats.vue?vue&type=style&index=0&id=40ad095c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ad095c"]])

export default __exports__